import create, { State } from 'zustand';

interface AuthState extends State {
  loggedInUser: any;
  currentHospitalId: string | undefined;
  setLoggedInUser: (user: any) => void;
  setCurrentHospitalId: (id: string | undefined) => void;
  setIsMultipleHospitals: (is: boolean) => void;
  isMultipleHospitals: Boolean;
}

const useAuthStore = create<AuthState>((set) => ({
  loggedInUser: undefined,
  setLoggedInUser: (user: any) => set(() => ({ loggedInUser: user })),
  currentHospitalId: undefined,
  setCurrentHospitalId: (id: string | undefined) =>
    set(() => ({ currentHospitalId: id })),
  isMultipleHospitals: false,
  setIsMultipleHospitals: (is: boolean) =>
    set(() => ({ isMultipleHospitals: is })),
}));

export default useAuthStore;
